<template>
  <!-- The full notice in a box over the page, for small screens where the
       header only has room for the icon (see R3SystemNotice.vue). Stays open
       until the user closes it. -->
  <DxPopup
    :visible="visible"
    :title="notice.title"
    :show-close-button="true"
    :hide-on-outside-click="false"
    :drag-enabled="false"
    width="90%"
    :max-width="420"
    height="auto"
    @hidden="$emit('close')"
  >
    <div class="r3-system-notice-popup">
      <div class="r3-system-notice-popup__type" :style="notice.colorStyle">
        <i :class="notice.iconClass"></i>
        <span v-if="notice.dateText">{{ notice.dateText }}</span>
      </div>
      <p v-if="notice.message" class="r3-system-notice-popup__message">{{ notice.message }}</p>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";

export default {
  components: { DxPopup },
  props: {
    visible: { type: Boolean, default: false },
    // { title, message, dateText, iconClass, colorStyle } from R3SystemNotice
    notice: { type: Object, required: true },
  },
  emits: ["close"],
};
</script>

<style scoped>
/* colored strip with the type icon and the date, then the message */
.r3-system-notice-popup__type {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 4px;
  font-weight: 600;
}

.r3-system-notice-popup__type .dx-icon {
  font-size: 20px;
  color: inherit;
}

.r3-system-notice-popup__message {
  margin: 12px 0 0;
  line-height: 1.4;
}
</style>
